import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'
import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {buildTextFieldConfiguration} from './buildTextFieldConfiguration'
import {useTextField} from './useTextField'

// AdditionalNotes
export const buildAdditionalNotesConfiguration = ({
  options: {constraints}
}: BuildConfigurationInput) =>
  buildTextFieldConfiguration('additionalNotes', constraints.notes.isEnabled, 0, 72)
export const useAdditionalNotes = () => {
  const additionalNotes = useTextField('additionalNotes')
  const {getFieldState} = useOrderProcessFormContext()
  const error = getFieldState('additionalNotes')?.error
  return {
    error,
    additionalNotes: additionalNotes.fieldValue,
    defaultAdditionalNotes: additionalNotes.defaultFieldValue,
    setAdditionalNotes: additionalNotes.setFieldValue,
    additionalNotesConfiguration: additionalNotes.fieldConfiguration as {
      enabled: boolean
      minLength?: number
      maxLength?: number
    }
  }
}

// DriverInstructions
export const buildDriverInstructionsConfiguration = ({
  options: {constraints}
}: BuildConfigurationInput) =>
  buildTextFieldConfiguration(
    'driverInstructions',
    constraints.driverInstructions?.isEnabled ?? false
  )
export const useDriverInstructions = () => {
  const driverInstructions = useTextField('driverInstructions')
  const {getFieldState} = useOrderProcessFormContext()
  const error = getFieldState('driverInstructions')?.error
  return {
    error,
    driverInstructions: driverInstructions.fieldValue,
    defaultDriverInstructions: driverInstructions.defaultFieldValue,
    setDriverInstructions: driverInstructions.setFieldValue,
    driverInstructionsConfiguration: driverInstructions.fieldConfiguration as {
      enabled: boolean
      minLength?: number
      maxLength?: number
    }
  }
}

// PoNumber
export const buildPoNumberConfiguration = ({options: {constraints}}: BuildConfigurationInput) => {
  return buildTextFieldConfiguration(
    'poNumber',
    constraints.poNumber?.isEnabled ?? false,
    constraints.poNumber?.minLength,
    constraints.poNumber?.maxLength
  )
}
export const usePoNumber = () => {
  const poNumber = useTextField('poNumber')
  const {getFieldState} = useOrderProcessFormContext()
  const error = getFieldState('poNumber')?.error
  return {
    error,
    poNumber: poNumber.fieldValue,
    defaultPoNumber: poNumber.defaultFieldValue,
    setPoNumber: poNumber.setFieldValue,
    poNumberConfiguration: poNumber.fieldConfiguration as {
      enabled: boolean
      minLength?: number
      maxLength?: number
    }
  }
}
